// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ecom-menu-badge[data-v-d39e0bc0]{align-items:center;aspect-ratio:1/1;border-radius:50%;display:flex;font-size:10px;justify-content:center;width:30px}.ecom-menu-badge__image[data-v-d39e0bc0]{height:24px;-o-object-fit:contain;object-fit:contain;width:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
